import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Typography,
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

export interface TipoFaturaOption {
  value: string;
  label: string;
}

export const TIPO_FATURA_OPTIONS: TipoFaturaOption[] = [
  { value: 'mensalidade', label: 'Mensalidade' },
  { value: 'servicos', label: 'Serviços' },
  { value: 'outros', label: 'Outros' },
];

interface TipoFaturaSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  variant?: 'outlined' | 'filled' | 'standard';
  allowClear?: boolean;
}

const TipoFaturaSelect: React.FC<TipoFaturaSelectProps> = ({
  value,
  onChange,
  label = 'Tipo de Fatura',
  fullWidth = true,
  size = 'small',
  disabled = false,
  error = false,
  helperText,
  variant = 'outlined',
  allowClear = true,
}) => {
  const handleChange = (event: any) => {
    onChange(event.target.value);
  };

  const handleClear = (event: React.MouseEvent) => {
    event.stopPropagation();
    onChange('');
  };

  return (
    <FormControl
      fullWidth={fullWidth}
      size={size}
      disabled={disabled}
      error={error}
      variant={variant}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        label={label}
        endAdornment={
          allowClear && value ? (
            <InputAdornment position="end" sx={{ mr: 2 }}>
              <ClearIcon
                onClick={handleClear}
                sx={{
                  cursor: 'pointer',
                  fontSize: '18px',
                  '&:hover': { color: 'error.main' },
                }}
              />
            </InputAdornment>
          ) : undefined
        }
      >
        <MenuItem value="">
          <em>Todos os tipos</em>
        </MenuItem>
        {TIPO_FATURA_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <Typography variant="caption" color={error ? 'error' : 'text.secondary'} sx={{ mt: 0.5, ml: 1.5 }}>
          {helperText}
        </Typography>
      )}
    </FormControl>
  );
};

export default TipoFaturaSelect;
